import { render, staticRenderFns } from "./EmailTokenExpired.vue?vue&type=template&id=535d4413&scoped=true&"
import script from "./EmailTokenExpired.vue?vue&type=script&lang=js&"
export * from "./EmailTokenExpired.vue?vue&type=script&lang=js&"
import style0 from "./EmailTokenExpired.vue?vue&type=style&index=0&id=535d4413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d4413",
  null
  
)

export default component.exports